import { organizationService } from "../organization.service";
import { alertActions } from "../../../../_services/store/alert.actions";
import { myOrganizationReducerActions } from "../../../../_services/store";
import { reloadUserData } from "../../../../user/services/store/authentication.actions";
import HubspotPropertiesEnum from "../../constants/HubspotPropertiesEnum";
import stringUtils from "../../../../_services/string-utils";
import ReactPixel from "react-facebook-pixel";
import TagManager from "react-gtm-module";
import { userService } from "../../../../user/services/user.service";
import { OrganizationType } from "../../../../_statics/OrganizationType";

export const getOrganization = () => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.getOrganizationRequest());
        try {
            const organization = await organizationService.getOrganization();
            dispatch(myOrganizationReducerActions.getOrganizationSuccess(organization));
            dispatch(myOrganizationReducerActions.setEditOrganization(organization));
            return organization;
        } catch (error) {
            dispatch(myOrganizationReducerActions.getOrganizationFailure(error));
            return error;
        }
    };
};

export const updateOrganization = (organization) => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.updateOrganizationRequest());
        try {
            const updatedOrganization = await organizationService.updateOrganization(organization);
            dispatch(myOrganizationReducerActions.updateOrganizationSuccess(updatedOrganization));
            dispatch(myOrganizationReducerActions.setEditOrganization(updatedOrganization));
            dispatch(alertActions.generalSuccessAndClear("Daten wurden erfolgreich gespeichert", 3000));
            return updatedOrganization;
        } catch (error) {
            dispatch(myOrganizationReducerActions.updateOrganizationFailure(error));
            if (organization.organizationType !== OrganizationType.LEX_OFFICE) {
                dispatch(alertActions.generalErrorAndClear(error, 3000));
            }
            return Promise.reject(error);
        }
    };
};

export const fireGTMTagAfterSuccessfulUserRegistration = () => {
    TagManager.dataLayer({
        dataLayer: {
            event: "conversion",
            send_to: process.env.REACT_APP_GOOGLE_TAG_USER_ACCOUNT_CREATION,
        },
    });
    console.log("GTM event fired!");
};

export const fireMetaTagAfterSuccessfulUserRegistration = () => {
    ReactPixel.track("AppInstalled");
    console.log("META event fired!");
};

export const updateAllowedApps = (externalUUID, allowedApps) => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.updateAllowedAppsRequest());
        try {
            await organizationService.updateAllowedApps(externalUUID, allowedApps);
            dispatch(myOrganizationReducerActions.updateAllowedAppsSuccess());
            dispatch(reloadUserData());
            dispatch(alertActions.generalSuccessAndClear("Update erfolgreich", 3000));
        } catch (error) {
            dispatch(myOrganizationReducerActions.updateAllowedAppsFailure(error));
            dispatch(alertActions.generalErrorAndClear(error.message, 3000));
        }
    };
};

export const registerUserToOrganization = (user) => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.registerUserToOrganizationRequest());
        try {
            const registeredUser = await organizationService.registerUserToOrganization(user);
            dispatch(myOrganizationReducerActions.registerUserToOrganizationSuccess(registeredUser));
            dispatch(getOrganization());
            dispatch(alertActions.generalSuccessAndClear("Nutzer erfolgreich hinzugefügt", 5000));
        } catch (error) {
            dispatch(myOrganizationReducerActions.registerUserToOrganizationFailure(error));
        }
    };
};

export const updateUserInOrganization = (user) => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.registerUserToOrganizationRequest());
        try {
            const updatedUser = await userService.updateUserProfileInfo(user);
            dispatch(myOrganizationReducerActions.registerUserToOrganizationSuccess(updatedUser));
            await dispatch(getOrganization());
            dispatch(alertActions.generalSuccessAndClear("Benutzer erfolgreich aktualisiert", 5000));
        } catch (error) {
            dispatch(myOrganizationReducerActions.registerUserToOrganizationFailure(error));
        }
    };
};

export const removeUserFromOrganization = (user, organizationUUID) => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.removeUserFromOrganizationRequest());
        try {
            const removedUser = await organizationService.removeUserFromOrganization(user, organizationUUID);
            dispatch(myOrganizationReducerActions.removeUserFromOrganizationSuccess(removedUser));
            dispatch(getOrganization());
            dispatch(alertActions.generalSuccessAndClear("Nutzer erfolgreich entfernt", 3000));
        } catch (error) {
            dispatch(myOrganizationReducerActions.removeUserFromOrganizationFailure(error));
        }
    };
};

export const getHubspotProperties = (hubspotId, properties) => {
    return async (dispatch) => {
        try {
            dispatch(myOrganizationReducerActions.getHubspotPropertiesRequest());
            const requestDto = {
                hubspotId: hubspotId,
                properties: properties,
            };

            const hubspotProperties = await organizationService.getHubspotProperties(requestDto);
            dispatch(myOrganizationReducerActions.setHubspotId(hubspotId));
            dispatch(
                myOrganizationReducerActions.getHubspotPropertiesSuccess({
                    ...hubspotProperties,
                    hubspotId: hubspotId,
                })
            );
        } catch (error) {
            if (error.message) {
                dispatch(myOrganizationReducerActions.getHubspotPropertiesFailure(error.message));
            } else {
                dispatch(myOrganizationReducerActions.getHubspotPropertiesFailure(error));
            }
        }
    };
};

export const setProductFruitsUser = (user, hubspotProperties) => {
    return async (dispatch) => {
        if (user && user.selectedOrganization) {
            dispatch(
                myOrganizationReducerActions.setProductFruitsUser({
                    hubspotId: hubspotProperties ? hubspotProperties.hubspotId : user.selectedOrganization.hubspotId,
                    organizationUUID: user.selectedOrganization.externalUUID,
                    username: user.externalUUID,
                    firstname: user.firstName,
                    lastname: user.lastName,
                    role: stringUtils.adjustPropsForProductFruits(user.userRole),
                    email: user.mail,
                    props: {
                        modules: user.selectedOrganization.allowedApps
                            ? stringUtils.adjustPropsForProductFruits(user.selectedOrganization.allowedApps)
                            : {},
                        rechnungsprinter: user.selectedOrganization.pathwayBillingStatus,
                        onboardingStatus: stringUtils.adjustPropsForProductFruits(
                            user.selectedOrganization.onboardingStatus
                        ),
                        abrechnungsStatus: stringUtils.adjustPropsForProductFruits(
                            user.selectedOrganization.billingStatus
                        ),
                        organizationType: user.selectedOrganization.organizationType,
                        companyName: user.selectedOrganization.name,
                        platformUserType: stringUtils.adjustPropsForProductFruits(user.platformUserType),
                        apiVerbindungen: hubspotProperties
                            ? stringUtils.adjustPropsForProductFruits(
                                  hubspotProperties[HubspotPropertiesEnum.CONNECTED_AUTH_DATA]
                              )
                            : {},
                        missingBookingStack: hubspotProperties
                            ? stringUtils.adjustPropsForProductFruits(
                                  hubspotProperties[HubspotPropertiesEnum.MISSING_BOOKING_STACKS]
                              )
                            : {},
                        activeBookingStack: hubspotProperties
                            ? stringUtils.adjustPropsForProductFruits(
                                  hubspotProperties[HubspotPropertiesEnum.ACTIVE_BOOKING_STACKS]
                              )
                            : {},
                        zahlungsartHinterlegt: hubspotProperties
                            ? stringUtils.adjustPropsForProductFruits(
                                  hubspotProperties[HubspotPropertiesEnum.PAYMENT_TYPE]
                              )
                            : undefined,
                        steuerberaterAccountHinterlegt: hubspotProperties
                            ? hubspotProperties[HubspotPropertiesEnum.ASSOCIATED_TAX_CONSULTANT]
                            : undefined,
                        datevFormatEinstellungenHinterlegt: hubspotProperties
                            ? hubspotProperties[HubspotPropertiesEnum.VALID_DATEV_SETTINGS]
                            : undefined,
                        shopifyRechnungsprinterStatus: hubspotProperties
                            ? hubspotProperties[HubspotPropertiesEnum.SHOPIFY_RECHNUNGSPRINTER_STATUS]
                            : undefined,
                    },
                    group: {
                        groupId: user.selectedOrganization.externalUUID,
                    },
                })
            );
        }
    };
};

export const initializeProductFruitsUser = (user) => {
    return async (dispatch) => {
        try {
            let hubspotProperties;
            if (user && user.selectedOrganization) {
                if (user.selectedOrganization.hubspotId) {
                    hubspotProperties = await organizationService.getHubspotProperties({
                        hubspotId: user.selectedOrganization.hubspotId,
                        properties: [
                            HubspotPropertiesEnum.CONNECTED_AUTH_DATA,
                            HubspotPropertiesEnum.MISSING_BOOKING_STACKS,
                            HubspotPropertiesEnum.PAYMENT_TYPE,
                            HubspotPropertiesEnum.ASSOCIATED_TAX_CONSULTANT,
                            HubspotPropertiesEnum.TECHNICAL_EXPIRATION_DATE,
                            HubspotPropertiesEnum.VALID_DATEV_SETTINGS,
                            HubspotPropertiesEnum.ACTIVE_BOOKING_STACKS,
                            HubspotPropertiesEnum.SHOPIFY_RECHNUNGSPRINTER_STATUS,
                            HubspotPropertiesEnum.LAST_INVOICE_AMOUNT,
                            HubspotPropertiesEnum.ONBOARDING_STATUS,
                            HubspotPropertiesEnum.BOOKED_ADDITIONAL_FEATURES,
                        ],
                    });
                }
                dispatch(setProductFruitsUser(user, hubspotProperties));
                dispatch(myOrganizationReducerActions.setHubspotProperties(hubspotProperties));
            }
        } catch (error) {
            dispatch(setProductFruitsUser(user, null));
        }
    };
};

export const submitAnalytics = (organizationUUID, analytics) => {
    organizationService.sendHubspotAnalytics(organizationUUID, analytics);
};

export const getDashboardData = (isTaxAgency = false) => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.setDashboardDataRequest());
        try {
            const dashboardData = isTaxAgency
                ? await organizationService.getTaxAgencyDashboardData()
                : await organizationService.getDashboardData();
            dispatch(myOrganizationReducerActions.setDashboardData(dashboardData));
            if (isTaxAgency && Array.isArray(dashboardData)) {
                // The tax-agency response carries empty scheduledTasks for a fast first render —
                // prefetch the per-org status data in the background so the Statusübersicht is
                // (usually) already there when the user expands it (issue 41294).
                dashboardData.forEach((organization) => {
                    dispatch(getTaxAgencyOrgDetails(organization.externalUUID));
                });
            }
            return dashboardData;
        } catch (error) {
            dispatch(myOrganizationReducerActions.setDashboardData(null));
        }
    };
};

export const getTaxAgencyOrgDetails = (organizationUUID) => {
    return async (dispatch) => {
        dispatch(myOrganizationReducerActions.getTaxAgencyOrgDetailsRequest(organizationUUID));
        try {
            const details = await organizationService.getTaxAgencyOrgDetails(organizationUUID);
            dispatch(myOrganizationReducerActions.getTaxAgencyOrgDetailsSuccess({ organizationUUID, details }));
            return details;
        } catch (error) {
            dispatch(myOrganizationReducerActions.getTaxAgencyOrgDetailsFailure(organizationUUID));
        }
    };
};

// Refresh after task changes: in tax-agency mode only the affected org's details are re-fetched
// (the basic card data doesn't change); otherwise the whole dashboard is reloaded.
const refreshDashboardAfterTaskChange = (dispatch, isTaxAgency, organizationUUID) => {
    if (isTaxAgency && organizationUUID) {
        return dispatch(getTaxAgencyOrgDetails(organizationUUID));
    }
    return dispatch(getDashboardData(isTaxAgency));
};

export const createScheduledTask = (taskDto) => {
    return async (dispatch) => {
        try {
            await organizationService.createScheduledTask(taskDto);
        } catch (error) {
            console.error("Error creating scheduled task:", error);
        }
    };
};

export const updateScheduledTask = (taskUUID, taskDto, isTaxAgency = false, organizationUUID = null) => {
    return async (dispatch) => {
        try {
            dispatch(myOrganizationReducerActions.updateScheduledTaskRequest());
            const response = await organizationService.updateScheduledTask(taskUUID, taskDto);

            await refreshDashboardAfterTaskChange(dispatch, isTaxAgency, organizationUUID);

            dispatch(myOrganizationReducerActions.updateScheduledTaskSuccess(response));
            dispatch(myOrganizationReducerActions.toggleScheduledTaskModal(null));

            return response;
        } catch (error) {
            if (error.message) {
                dispatch(myOrganizationReducerActions.updateScheduledTaskFailure(error.message));
            } else {
                dispatch(myOrganizationReducerActions.updateScheduledTaskFailure(error));
            }
        }
    };
};

export const toggleScheduledTaskModal = (task) => {
    return (dispatch) => {
        dispatch(myOrganizationReducerActions.toggleScheduledTaskModal(task));
    };
};

export const restartScheduledTask = (taskUUID, isTaxAgency = false, organizationUUID = null) => {
    return async (dispatch) => {
        try {
            dispatch(myOrganizationReducerActions.restartScheduledTaskRequest());
            await organizationService.restartScheduledTask(taskUUID);

            await refreshDashboardAfterTaskChange(dispatch, isTaxAgency, organizationUUID);

            dispatch(myOrganizationReducerActions.restartScheduledTaskSuccess());
            dispatch(alertActions.generalSuccessAndClear("Aufgabe wurde erfolgreich neu gestartet", 3000));
        } catch (error) {
            const errorMessage = error.message || "Fehler beim Neustarten der Aufgabe";
            dispatch(myOrganizationReducerActions.restartScheduledTaskFailure(errorMessage));
            dispatch(alertActions.generalErrorAndClear(errorMessage, 3000));
        }
    };
};

export const updateLastImportDate = (taskUUID, date, isTaxAgency = false, organizationUUID = null) => {
    return async (dispatch) => {
        try {
            dispatch(myOrganizationReducerActions.updateLastImportDateRequest());
            await organizationService.updateLastImportDate(taskUUID, date);

            await refreshDashboardAfterTaskChange(dispatch, isTaxAgency, organizationUUID);

            dispatch(myOrganizationReducerActions.updateLastImportDateSuccess());
            dispatch(alertActions.generalSuccessAndClear("Importdatum wurde erfolgreich aktualisiert", 3000));
        } catch (error) {
            const errorMessage = error.message || "Fehler beim Aktualisieren des Importdatums";
            dispatch(myOrganizationReducerActions.updateLastImportDateFailure(errorMessage));
            dispatch(alertActions.generalErrorAndClear(errorMessage, 3000));
        }
    };
};

export const removeDeletionDate = (organizationUUID) => {
    return async (dispatch) => {
        try {
            return await organizationService.removeDeletionDateFromOrganization(organizationUUID);
        } catch (error) {
            console.error("Error removing deletion date:", error);
        }
    };
};

// List + revoke go through the action layer for consistent toasts. The one-time plaintext from generate/rotate
// is intentionally NOT handled here — it must stay in component local state, never Redux (see ServiceAccountTokenCard).
export const getServiceAccountTokens = () => {
    return async (dispatch) => {
        try {
            return await organizationService.getServiceAccountTokens();
        } catch (error) {
            dispatch(
                alertActions.generalErrorAndClear("Die Service-Account-Tokens konnten nicht geladen werden.", 5000)
            );
            // Return null (not []) so the card can distinguish "load failed" from "no tokens yet".
            return null;
        }
    };
};

// Super-user only: read-only listing of another user's tokens for the admin area (no mutation actions).
export const getServiceAccountTokensForUser = (userExternalUUID) => {
    return async (dispatch) => {
        try {
            return await organizationService.getServiceAccountTokensForUser(userExternalUUID);
        } catch (error) {
            dispatch(
                alertActions.generalErrorAndClear("Die Service-Account-Tokens konnten nicht geladen werden.", 5000)
            );
            return [];
        }
    };
};

export const revokeServiceAccountToken = (id) => {
    return async (dispatch) => {
        try {
            await organizationService.revokeServiceAccountToken(id);
            dispatch(alertActions.generalSuccessAndClear("Token wurde erfolgreich widerrufen.", 3000));
            return true;
        } catch (error) {
            dispatch(
                alertActions.generalErrorAndClear(
                    "Der Token konnte nicht widerrufen werden. Bitte versuche es erneut.",
                    5000
                )
            );
            return false;
        }
    };
};

export const migrateToStripe = (organizationUUID, businessAddress) => {
    return async (dispatch) => {
        try {
            dispatch(myOrganizationReducerActions.migrateToStripeRequest());
            const response = await organizationService.migrateToStripe(organizationUUID, businessAddress);
            dispatch(myOrganizationReducerActions.migrateToStripeSuccess(response.checkoutSessionSecret));
            dispatch(myOrganizationReducerActions.setEditOrganization(response.organization));
        } catch (error) {
            dispatch(myOrganizationReducerActions.migrateToStripeFailure(error));
        }
    };
};
